<template>
    <div>{{ status }}</div>
</template>

<script>
    // import {destroyToken} from "@/authentication";
    // import GetUrl from "@/components/mixins/GetUrl";
    // import {axiosGet} from "@/funclib";
    // import axios from 'axios'
    import User from "../mixins/User";

    export default {
        name: "LogOutUser",
        mixins: [User],
        data: function () {
            return {
            }
        },
        beforeCreate () {
            this.logoutUser();
            if (!this.loggedIn()) {
                this.$route.push({ name: 'home' });
            }
        },
        computed: {
            status () {
                if (this.loggedIn) {
                    return 'Logged In';
                }
                return 'Logged out.';
            },
        },
    }
</script>

<style scoped>

</style>
